import React from "react"
import styles from "./form.module.css"

const RangeInput = ({ value, onChange = () => { }, min = 0, max = 100, step = 1, className = "", ...props }) => (
    <input
        type="range"
        className={`${styles.rangeInput} ${className}`.trim()}
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
        {...props}
    />
)

export default RangeInput
